type TypeFormat = {
  currency?: string;
  amount: number;
  isBalance?: boolean;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
};
export default ({
  currency,
  amount,
  isBalance = false,
  minimumFractionDigits = 2,
  maximumFractionDigits = 2,
}: TypeFormat) => {
  const symbol = amount < 0 ? '-' : '+';

  const options: any = {
    minimumFractionDigits,
    maximumFractionDigits,
  };

  if (currency) {
    options.style = 'currency';
    options.currency = currency;
  }

  const amountFormatted = amount?.toLocaleString('en-AE', { ...options });

  return `${isBalance ? symbol : ''} ${amountFormatted}`;
};
